"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCATION_DEFAULT = {
  value: '',
  label: 'Todo el país'
};